import { h } from 'preact';
export const Percent = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "19", y1: "5", x2: "5", y2: "19" }),
        h("circle", { cx: "6.5", cy: "6.5", r: "2.5" }),
        h("circle", { cx: "17.5", cy: "17.5", r: "2.5" })));
};
//# sourceMappingURL=percent.js.map